import React, { useEffect, useState } from 'react';
import { CREW_BOARD_QUOTES, crewBoardQuoteStartIndex } from '../../utils/crewJobsBoardMedia';

export const CREW_BOARD_QUOTE_ROTATE_MS = 7500;
export const CREW_BOARD_QUOTE_FIRST_HOLD_MS = 6000;

const START_INDEX = crewBoardQuoteStartIndex();

const CrewBoardQuoteCarousel: React.FC = () => {
  const [index, setIndex] = useState(START_INDEX);
  const [paused, setPaused] = useState(false);
  const [cycleStarted, setCycleStarted] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || paused || CREW_BOARD_QUOTES.length < 2) return undefined;

    if (!cycleStarted) {
      const id = window.setTimeout(() => {
        setIndex(current => (current + 1) % CREW_BOARD_QUOTES.length);
        setCycleStarted(true);
      }, CREW_BOARD_QUOTE_FIRST_HOLD_MS);
      return () => window.clearTimeout(id);
    }

    const id = window.setInterval(() => {
      setIndex(current => (current + 1) % CREW_BOARD_QUOTES.length);
    }, CREW_BOARD_QUOTE_ROTATE_MS);
    return () => window.clearInterval(id);
  }, [paused, cycleStarted]);

  const active = CREW_BOARD_QUOTES[index];

  return (
    <div
      className={`crew-board-quotes${paused ? ' is-paused' : ''}`}
      role="region"
      aria-roledescription="carousel"
      aria-label="Field quotes"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={() => setPaused(false)}
    >
      <div className="crew-board-quotes-stage">
        {CREW_BOARD_QUOTES.map((quote, i) => (
          <blockquote
            key={quote.author}
            className={`crew-board-quote${i === index ? ' is-active' : ''}`}
            aria-hidden={i !== index}
          >
            <p className="crew-board-quote-text">“{quote.text}”</p>
            <cite className="crew-board-quote-author">
              <span className="crew-board-quote-name">{quote.author}</span>
              <span className="crew-board-quote-role">{quote.role}</span>
            </cite>
          </blockquote>
        ))}
      </div>
      <p className="crew-board-quotes-live" aria-live="polite">
        {active ? `${active.author}. ${active.text}` : ''}
      </p>
    </div>
  );
};

export default CrewBoardQuoteCarousel;
